import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useLocation, Link, useNavigate } from "react-router-dom";
import Login from "./Login";
import OtpVerify from "./OtpVerify";
import { isDevelopmentMode } from "../services/base";

export default function Verify() {
  const navigate = useNavigate();
  const location = useLocation();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 769px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 769px)" });
  try {
    var phone = location?.state?.phone;
    var email = location?.state?.email;
    var islog = location?.state?.islog;
    var activeMethod = location?.state?.activeMethod;
  } catch (e) {
    navigate("/sign");
    return;
  }
  if (!phone && !email && !islog) {
    navigate("/sign");
    return;
  }

  return (
    <>
      {isDevelopmentMode() ? (
        <OtpVerify
          destination={phone ? phone : email}
          isLogin={false}
          activeMethod={location?.state?.activeMethod}
        />
      ) : isDesktopOrLaptop ? (
        <>
          {islog ? (
            <Login
              destination={phone ? phone : email}
              activeMethod={activeMethod}
            />
          ) : (
            <OtpVerify
              destination={phone ? phone : email}
              isLogin={false}
              activeMethod={location?.state?.activeMethod}
            />
          )}
        </>
      ) : (
        isTabletOrMobile && (
          <>
            {islog ? (
              <Login
                destination={phone ? phone : email}
                activeMethod={activeMethod}
              />
            ) : (
              <OtpVerify
                destination={phone ? phone : email}
                isLogin={false}
                activeMethod={location?.state?.activeMethod}
              />
            )}
          </>
        )
      )}
    </>
  );
}
